var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardBody"},[(_vm.cardBodyTitle)?_c('h2',[_vm._v(_vm._s(_vm.cardBodyTitle))]):_vm._e(),(_vm.cardBodySubTitle)?_c('h3',[_vm._v(_vm._s(_vm.cardBodySubTitle))]):_vm._e(),(_vm.cardBodyText)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.cardBodyText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }